%flex {
  display: flex;
  flex-direction: column;
  align-items: center;
}

%container-common {
  @extend %flex;

  margin: 32px 0;
}

.container {
  @extend %container-common;

  svg {
    width: var(--icon-size-empty-table);
    height: var(--icon-size-empty-table);
    margin: 0 0 15px;
  }
}

.text {
  color: var(--neutral-6-color);
}

.container-create-action {
  @extend %container-common;

  :global(.ant-empty-image) {
    height: auto;
    margin-bottom: 0;

    svg {
      width: 64px;
    }
  }

  :global(.ant-empty-description) {
    @extend %flex;
  }

  &.select-placement {
    margin: 0;
  }
}

.icon-progress {
  font-size: 36px;
  margin: 60px 0 0;
  animation-duration: 2.5s;
  color: var(--color-icon-scan-progress);
}

.icon-load-error {
  font-size: 34px;
  color: var(--neutral-6-color);
}
